// UNSTYLED: base shadcn/base-ui scaffolding — pulled in automatically as a dependency of Sidebar — styling and stories pending.
import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('tw:animate-pulse tw:rounded-md tw:bg-muted', className)}
      {...props}
    />
  );
}

export { Skeleton };
